let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let AuthedUserSession = require("../../utils/AuthedUserSession");

let modals = {
  TipOfTheDay: require("./TipOfTheDay"),
  EmailToCoworkers: require("./EmailToCoworkers"),
  WarnOfUnsavedChanges: require("./WarnOfUnsavedChanges"),
  PromptApplyActionList: require("./PromptApplyActionList"),
  PromptForReasonWhenCanceling: require("./PromptForReasonWhenCanceling"),
  PromptWhenEventConfirmed: require("./PromptWhenEventConfirmed"),
  PromptToChangeStatusForChildren: require("./PromptToChangeStatusForChildren"),
  ChangeActiveCompany: require("./ChangeActiveCompany"),
};
if (AuthedUserSession.is_st_family) {
  modals.RoyaltyChange = require("./RoyaltyChange");
  modals.EvaluationScoreChanged = require("./EvaluationScoreChanged");
  modals.EventRepChanged = require("./EventRepChanged");
  modals.EventCompanyChange = require("./EventCompanyChange");
  modals.PromptToChangeRepsForChildren = require("./PromptToChangeRepsForChildren");
  // modals.PromptRelayChanged = require("./PromptRelayChanged");
}

module.exports = dd.createClass({
  render() {
    let { url_args, Displaylists } = this.props;

    return dd.div(
      null,
      //All these modals need to be mounted on the page at all times
      //b/c they are constantly listening for radio events
      _.map(
        modals,
        function (Cmpt, name) {
          return Cmpt({ key: name, Displaylists, url_args });
        },
        this
      )
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/modals/index.js